// extracted by mini-css-extract-plugin
module.exports = {"control":"PaginationParametersControl_control__1LkM9","positioner":"PaginationParametersControl_positioner__1PAdh"};